// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import EarnExtraPointsTile from '../views';
import {
  getEarnExtraPointsDataState,
  getEarnExtraPointsFetchingState,
} from './EarnExtraPointsTile.selectors';
import { getEarnExtraPointsList } from './EarnExtraPointsTile.actions';
import EarnExtraPointsTileNewView from '../views/EarnExtraPointsTileNew.view';

export class EarnExtraPointsTileContainer extends React.PureComponent {
  componentDidMount() {
    const { getEarnExtraPointsListAction, isAccountOverview, isAccountDrawer } = this.props;
    if (!isAccountOverview || isAccountDrawer) {
      // in case of accountOverview this call will be triggered from EarnExtraPointsOverview container
      getEarnExtraPointsListAction();
    }
  }

  /**
   * @function render  Used to render the JSX of the component
   * @param    {[Void]} function does not accept anything.
   * @return   {[Object]} JSX of the component
   */
  render() {
    const { waysToEarn, isAccountOverview, isAccountDrawer, ...otherProps } = this.props;

    return isAccountDrawer || isAccountOverview ? (
      <EarnExtraPointsTileNewView
        waysToEarn={waysToEarn}
        isAccountOverview={isAccountOverview}
        isAccountDrawer={isAccountDrawer}
        {...otherProps}
      />
    ) : (
      <EarnExtraPointsTile
        waysToEarn={waysToEarn}
        isAccountOverview={isAccountOverview}
        {...otherProps}
      />
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    getEarnExtraPointsListAction: (payload) => {
      dispatch(getEarnExtraPointsList(payload));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    waysToEarn: getEarnExtraPointsDataState(state),
    isFetching: getEarnExtraPointsFetchingState(state),
  };
};

EarnExtraPointsTileContainer.propTypes = {
  getEarnExtraPointsListAction: PropTypes.func.isRequired,
  waysToEarn: PropTypes.shape([]),
  isAccountOverview: PropTypes.bool,
  isFetching: PropTypes.bool,
  isAccountDrawer: PropTypes.bool,
};

EarnExtraPointsTileContainer.defaultProps = {
  waysToEarn: [],
  isAccountOverview: false,
  isFetching: false,
  isAccountDrawer: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(EarnExtraPointsTileContainer);
